import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'store'

const itemDetailsState = (state: RootState) => state.itemDetails

export const selectExpandedItemId = createSelector(
  itemDetailsState,
  (state) => state.expandedItemId
)

export const selectItemDetails = createSelector(itemDetailsState, (state) => state.details)
export const selectItemDates = createSelector(itemDetailsState, (state) => state.dates)
export const selectItemAvailableFrom = createSelector(
  itemDetailsState,
  (state) => state.availableFrom
)

export const selectItem = (id: string) =>
  createSelector(itemDetailsState, (state) => state.details.find((item) => item.id === id))

export const selectSubEpisode = (id: string) =>
  createSelector(itemDetailsState, (state) =>
    state.details[0].subEpisodes.find((item) => item.id === id)
  )

export const selectLoadingItemId = (state: RootState) => state.itemDetails.loadingItemId
export const selectLoadingActionButtonId = createSelector(
  itemDetailsState,
  (state) => state.loadingActionButtonId
)

export const selectIsCourseCompleted = (state: RootState) => state.itemDetails.isCourseCompleted
export const selectIsLoading = createSelector(itemDetailsState, (state) => state.isLoading)
